import React, { PureComponent } from 'react';
interface SkinSelectProps {
    onChange: (value: number) => void,
    selectVal: number
}

class SkinSelect extends PureComponent<SkinSelectProps> {
    public render() {
        const { selectVal, onChange } = this.props;
        return (
            <div style={{borderBottom: '1px solid rgba(255, 255, 255, 0.1)', display: 'flex', 
                justifyContent: 'space-between', alignItems: 'center', padding: '0.4rem 0.4rem'}}>
                <div 
                    onClick={onChange.bind(this, 0)} 
                    className={ selectVal === 0 ? 'read-skin skin-show' : 'read-skin'} 
                    style={{background: '#c4b395 url('+ require('../img/readbg/skin-default-s.png') +') no-repeat center', backgroundSize: '100%'}}
                >
                    <svg id="icon-ok" viewBox="0 0 9 6">
                        <path d="M2.646 5.854a.5.5 0 0 0 .708 0l5-5a.5.5 0 0 0-.708-.708l-5 5h.708l-2.5-2.5a.5.5 0 0 0-.708.708l2.5 2.5z"/>
                    </svg>
                </div>
                <div 
                    onClick={onChange.bind(this, 1)}
                    className={ selectVal === 1 ? 'read-skin skin-show' : 'read-skin'} 
                    style={{background: '#cad9e8'}}
                >
                    <svg id="icon-ok" viewBox="0 0 9 6">
                        <path d="M2.646 5.854a.5.5 0 0 0 .708 0l5-5a.5.5 0 0 0-.708-.708l-5 5h.708l-2.5-2.5a.5.5 0 0 0-.708.708l2.5 2.5z"/>
                    </svg>
                </div>
                <div 
                    onClick={onChange.bind(this, 2)}
                    className={ selectVal === 2 ? 'read-skin skin-show' : 'read-skin'} 
                    style={{background: '#d1edd1'}}
                >
                    <svg id="icon-ok" viewBox="0 0 9 6">
                        <path d="M2.646 5.854a.5.5 0 0 0 .708 0l5-5a.5.5 0 0 0-.708-.708l-5 5h.708l-2.5-2.5a.5.5 0 0 0-.708.708l2.5 2.5z"/>
                    </svg>
                </div>
                <div 
                    onClick={onChange.bind(this, 3)}
                    className={ selectVal === 3 ? 'read-skin skin-show' : 'read-skin'} 
                    style={{background: '#e6e6e6'}}
                >
                    <svg id="icon-ok" viewBox="0 0 9 6">
                        <path d="M2.646 5.854a.5.5 0 0 0 .708 0l5-5a.5.5 0 0 0-.708-.708l-5 5h.708l-2.5-2.5a.5.5 0 0 0-.708.708l2.5 2.5z"/>
                    </svg>
                </div>
            </div>
        );
    }
}

export default SkinSelect;
